const initialState = {
  config: {},
};

export default function reducer(state = initialState) {
  // Nothing here, just for the state.
  return state;
}
